


















































































































































import { Component, Vue } from 'vue-property-decorator';
import { getNewPrograms, getNotificationsPrescriber, getProgramsCount } from '@/api/api';
import AuthModule from '../../store/AuthModule';
import ButtonLoading from '@/components/ButtonLoading.vue';

@Component({
  components: {
    ButtonLoading,
  },
})
export default class Login extends Vue {
  username: string = '';
  password: string = '';
  checkbox_remember_me: boolean = false;
  submit: boolean = false;
  showPopUp = false;
  userFirstname: string | null = '';
  nbOfProg: number = 0;
  loading: boolean = false;
  notifs: [] | null = null;

  /**
   * [1] On met alert à true au démarrage afin d'éviter une erreur de la part
   * de vuesax
   */
  alertMessage: string = '';
  alert: boolean = true;
  alertInitilized: boolean = false;
  promoters: number = 0;
  programs: number = 0;

  async getPrograms() {
    let programs = await getProgramsCount();
    console.log(programs.data);
    this.programs = programs.data.programs;
    this.promoters = programs.data.promoters;
  }

  async created() {
    /**
     * Voir l'explication concernant l'alert [1]
     */
    await this.$nextTick();
    this.alert = false;
    setTimeout(() => {
      this.alertInitilized = true;
    }, 300);
  }

  get usernameValid(): boolean {
    return this.username !== '';
  }

  get passwordValid(): boolean {
    return this.password !== '';
  }

  async onSubmit(): Promise<void> {
    this.submit = true;
    if (!this.usernameValid || !this.passwordValid) {
      return;
    }
    this.loading = true;
    try {
      await AuthModule.login({
        username: this.username,
        password: this.password,
      });

      let userId = AuthModule.userID;
      let roles = AuthModule.roles;
      let isTrial = AuthModule.isTrialActive;
      let isSubscription = AuthModule.isSubscriptionActive;
      let personal_color = AuthModule.personal_color;

      if (roles.indexOf('ROLE_ADMIN') == -1) {
        if (!isTrial && !isSubscription) {
          return this.$router.push({
            name: 'Services',
          });
        }
        let prog = await getNewPrograms(userId);
        let notif = await getNotificationsPrescriber();
        let notifData: [] = notif.data;
        if (notifData.length > 0) {
          this.notifs = notifData;
        }
        //@ts-ignore
        const numberOfProgs: number = prog.data;
        if (Number.isInteger(numberOfProgs) && numberOfProgs !== 0) {
          this.userFirstname = AuthModule.firstname;
          this.nbOfProg = numberOfProgs;
          this.showPopUp = true;
        } else {
          return this.routerPush()
        }
      } else {
        return this.$router.push({
          name: 'Services',
        });
      }

    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.code === 401 &&
        error.response.data.message === 'User account is disabled.'
      ) {
        this.alertMessage = `Votre compte n'est pas encore activé`;
      } else {
        this.alertMessage = `Nom d'utilisateur ou mot de passe incorrect`;
      }
      this.alert = true;
    } finally {
      this.loading = false;
    }
  }

  async routerPush() {
    this.showPopUp = false;
    this.$router.push({
      name: 'Services',
    });
  }
}
